/* eslint-disable react/require-default-props */

import React, { useMemo, useState } from "react";
import Itineraries from "../../../../components/Itineraries/Itineraries";
import CustomPoiModal from "../../../../../../components/CustomPoiModal/CustomPoiModal";
import usePlan from "../../../../../../hooks/usePlan";
import classes from "./PlanContainer.module.scss";

interface IPlanContainer {
  planDayIndex: number;
  changePlanDayIndex: (newPlanDayIndex: number) => void;
  show: boolean;
  alternativesStepId?: number;
  setAlternativesStepId: (stepId?: number) => void;
  // showExplorePlaces: () => void;
  // showLocalExperiences: () => void;
  // selectedPoiCategoryGroup: (poiCategoryGroup: Model.PoiCategoryGroup) => void;
  // selectedPoiCategoryIds: number[];
  // poiCategoryGroups: Model.PoiCategoryGroup[];
  gygTourIds: number[];
  bbTourIds: number[];
  viatorTourIds: string[];
  toristyTourIds: string[];
  toursLoading: boolean;
  setShowCloneModal: (show: boolean) => void;
  onBookingClick: () => void;
}

const PlanContainer: React.FC<IPlanContainer> = ({
  planDayIndex,
  changePlanDayIndex,
  show,
  alternativesStepId,
  setAlternativesStepId,
  // showExplorePlaces,
  // showLocalExperiences,
  // selectedPoiCategoryGroup,
  // selectedPoiCategoryIds,
  // poiCategoryGroups,
  gygTourIds,
  bbTourIds,
  viatorTourIds,
  toristyTourIds,
  toursLoading,
  setShowCloneModal,
  onBookingClick,
}) => {
  const { plans, planUpdateOrders, planUpdateTime } = usePlan();
  const [showCustomPoiModal, setShowCustomPoiModal] = useState<boolean>(false);
  const plansIdDate = useMemo(
    () => plans?.map(p => ({ id: p.id, date: p.date })) || [],
    [plans]
  );
  const plansIdDateWithTimeframe = useMemo(
    () =>
      plans?.map(p => ({
        id: p.id,
        date: p.date,
        startTime: p.startTime,
        endTime: p.endTime,
      })) || [],
    [plans]
  );

  const planContainerClasses = [classes.planContainer];
  if (!window.tconfig.SHOW_OVERVIEW)
    planContainerClasses.push("trip-layout-container-height");
  else planContainerClasses.push("trip-layout-container-height-tab");
  if (show) planContainerClasses.push(classes.planContainerOpen);
  else planContainerClasses.push(classes.planContainerClose);

  return (
    <>
      <div className={planContainerClasses.join(" ")}>
        <Itineraries
          plans={plans}
          plansIdDate={plansIdDate}
          plansIdDateWithTimeframe={plansIdDateWithTimeframe}
          planUpdateOrders={planUpdateOrders}
          planUpdateTime={planUpdateTime}
          alternativesStepId={alternativesStepId}
          setAlternativesStepId={setAlternativesStepId}
          planDayIndex={planDayIndex}
          changePlanDayIndex={changePlanDayIndex}
          customPoiModalShow={() => setShowCustomPoiModal(!showCustomPoiModal)}
          // selectedPoiCategoryIds={selectedPoiCategoryIds}
          gygTourIds={gygTourIds}
          bbTourIds={bbTourIds}
          viatorTourIds={viatorTourIds}
          toristyTourIds={toristyTourIds}
          toursLoading={toursLoading}
          setShowCloneModal={setShowCloneModal}
          onBookingClick={onBookingClick}
        />
      </div>

      <CustomPoiModal
        dayIndex={planDayIndex}
        plansIdDate={plansIdDate}
        showModal={showCustomPoiModal}
        setShowModal={() => setShowCustomPoiModal(!showCustomPoiModal)}
      />
    </>
  );
};

export default PlanContainer;
